import * as React from "react";

function SvgWindowMaximizeSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M20.125 3.25H3.875C2.84 3.25 2 4.09 2 5.125v13.75c0 1.035.84 1.875 1.875 1.875h16.25c1.035 0 1.875-.84 1.875-1.875V5.125c0-1.035-.84-1.875-1.875-1.875zM19.5 9.5h-15V6.219a.47.47 0 01.469-.469H19.03a.47.47 0 01.469.469V9.5z"
        fill="currentColor"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgWindowMaximizeSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
